import React, { FC, ReactNode } from 'react'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import FAIcon from './FAIcon'

interface SectionHeaderProps {
  title: string | ReactNode,
  titleIcon?: string | ReactNode,
  icon?: string,
  titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly',
  borderBottom?: boolean,
}

const SectionHeader: FC<React.PropsWithChildren<SectionHeaderProps>> = ({
  title,
  icon,
  titleVariant = 'h3',
  justify = 'flex-end',
  borderBottom = true,
  children,
}) => {

  const theme = useTheme()

  // Convert the primary color to RGB values
  const primaryColor = theme.palette.primary.main
  const rgbValues = primaryColor.replace(/^#/, '').match(/.{2}/g)?.map(x => parseInt(x, 16))

  return (
    <Box
      className='container'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        py: 2,
        px: 2,
        ...(borderBottom && {
          borderImage: `linear-gradient(90deg, #FFFFFF, rgba(${rgbValues?.[0]}, ${rgbValues?.[1]}, ${rgbValues?.[2]}, 1) 2%, rgba(${rgbValues?.[0]}, ${rgbValues?.[1]}, ${rgbValues?.[2]}, 1) 98%, #FFFFFF 100% ) 1`,
          borderWidth: '0 0 thin 0',
          borderStyle: 'solid',
        }),
      }}
    >
      {
        icon && (
          <FAIcon
            iconName={ icon }
            fontSize="2.2rem"
            iconSx={{
              pl: '0px',
              mr: 2,
            }}
          />
        )
      }
      <Box
        className='title'
        sx={{
          flexGrow: 0,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          overflowX: 'ellipsis',
        }}
      >
        {
          typeof(title) === 'string' ? (
            <Typography
              variant={ titleVariant }
              color={ theme.palette.primary.main }
            >
              { title }
            </Typography>
          ) : title
        }
        
      </Box>
      <Box 
        className='buttons'
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: justify,
        }}
      >
        { children }
      </Box>
    </Box>
    
  )
}

export default SectionHeader